import { Helmet } from 'react-helmet-async';

const Hero = ({
  imageUrl = '/images/header/main.webp',
  alt = '未経験歓迎のキャバクラ求人LP「New-Nightlife」トップ画像',
  focal = 'center 30%',
}) => {
  const sizes = '100vw';

  return (
    <>
      <Helmet>
        <meta property="og:image:alt" content="New-Nightlifeのトップ画像" />
        <style>{`
          .hero-wrap {
            position: relative;
            width: 100%;
            margin: 0;
            overflow: hidden;
          }
          .hero-media {
            width: 100%;
            height: 58vh;
            max-height: 720px;
            display: block;
            object-fit: cover;
          }
          @media (min-width: 1024px) {
            .hero-media { height: 56vh; }
          }
        `}</style>
      </Helmet>

      <section className="hero-wrap" aria-label="サイトのトップビジュアル">
        <picture>
          <source
            srcSet="/images/header/main.webp"
            type="image/webp"
            sizes={sizes}
          />
          <img
            className="hero-media"
            src={
              imageUrl.endsWith('.webp')
                ? '/images/header/main.webp'
                : '/images/header/main.png'
            }
            alt={alt}
            width={1170}
            height={1560}
            style={{ objectPosition: focal }}
            fetchPriority="high"
            decoding="async"
          />
        </picture>
      </section>
    </>
  );
};

export default Hero;
